import React from "react";
import styled from "styled-components";
import { Tag } from "@blueprintjs/core";

import { Link } from "@components/Link";

export const StickerContainer = styled.div`
  position: relative;
  padding: 0.6em;
  border: 1px solid #eaeaea;
  box-sizing: border-box;
  border-radius: 10px;
  transition: border-color 0.2s ease;
  ${Link}:hover & {
    border-color: #0974d7;
  }
`;

const SelectedContainer = styled(StickerContainer)`
  border-color: #0974d7;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`;

const Title = styled.h4`
  margin: 0;
  margin-bottom: 8px;
  font-size: var(--global-font-size-s);
  line-height: 23px;
  white-space: nowrap;
  overflow: hidden;
  flex: 1;
  color: #222;

  ${Link}:hover & {
    color: #0974d7;
  }
`;

const Text = styled.div`
  margin: 0;
  font-size: var(--global-font-size-xs);
  line-height: 16px;
  color: #777777;
`;

const StyledTag = styled(Tag)`
  margin-left: auto;
  margin-right: 0px;
  margin-top: 0px;
  height: 20px;
`;

interface Props {
  title?: React.ReactNode;
  tag?: React.ReactNode;
  linkTo?: string;
  onClick?: React.MouseEventHandler;
  selected?: boolean;
}

export const Sticker: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  title,
  tag,
  linkTo,
  onClick,
  selected = false,
}) => {
  const El = selected ? SelectedContainer : StickerContainer;
  const sticker = (
    <El onClick={onClick}>
      <Header>
        {title && <Title>{title}</Title>}
        {tag && (
          <StyledTag style={{ fontSize: 8 }} minimal intent="warning">
            {tag}
          </StyledTag>
        )}
      </Header>
      <Text>{children}</Text>
    </El>
  );

  if (linkTo !== undefined) {
    if (linkTo.startsWith("https://")) {
      return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a // nosemgrep: typescript.react.security.audit.react-missing-noreferrer.react-missing-noreferrer, nosemgrep: typescript.react.security.audit.react-missing-noopener.react-missing-noopener
          href={linkTo}
          target="_blank"
          rel={
            linkTo.startsWith("https://r2c.dev/")
              ? "noopener"
              : "noopener noreferrer"
          }
        >
          {sticker}
        </a>
      );
    } else {
      return <Link to={linkTo}>{sticker}</Link>;
    }
  }
  return sticker;
};
